var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertsBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 17 17",
    style: {
      enableBackground: "new 0 0 17 17"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#06B2BC;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home",
    transform: "translate(-28.000000, -217.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Information-Icon",
    transform: "translate(28.000000, 217.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.3,11H7.6v1.7h1.7V11z M8.5,4.2c0.5,0,0.8,0.4,0.8,0.8v3.4C9.3,9,9,9.3,8.5,9.3C8,9.3,7.6,9,7.6,8.5V5.1 C7.6,4.6,8,4.2,8.5,4.2L8.5,4.2z M8.5,17c4.7,0,8.5-3.8,8.5-8.5S13.2,0,8.5,0S0,3.8,0,8.5S3.8,17,8.5,17L8.5,17z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertsBlue);
export default __webpack_public_path__ + "static/media/alerts-blue.30c87122add11570248dcd07897b2c3a.svg";
export { ForwardRef as ReactComponent };